<template>
  <transition name="global-account-panel__wrappers">
    <div v-if="isExpanded" v-click-outside="Close" class="global-panel global-panel__left">
      <FocusLock>
        <div class="global-panel__inner-scroll">

          <button @click="Close()" class="close gds-button-circle gds-icon-close-small gds-secondary">
            <span class="gds-visibility--hide-visually">Close</span>
          </button>
          <p class="gds-display-2 gds-space-stack-m">Switch Account</p>
          <p class="gds-space-stack-l">Select the account you'd like to view.</p>
          <div v-if="isAdmin || isAdminLite" class="gds-space-stack-l">
            <div class="global-panel__account-type-header gds-font-demi gds-text-grey">Account Ghosting</div>
            <div
              v-for="account of ghostAccounts"
              :key="account.accountNumber"
              @click="SelectAccount(account)"
              @keyup.enter="SelectAccount(account)"
              class="global-panel__account-row"
              tabindex="0"
            >
              <div v-if="account.photoUrl" :style="{backgroundImage: 'url(' + GetResizedAccountPhoto(account.photoUrl) + ')'}" class="small-round-img"></div>
              <div v-if="!account.photoUrl" class="small-round-img"></div>
              <div>
                <p class="gds-display-0 gds-space-stack-s">{{account | accountName}}</p>
                <div class="gds-linebreaks">{{account.address | addressFormat({ separator: "\n", skipFirst: true })}}</div>
              </div>
            </div>
            <div class="global-panel__account-link">
              <a href="/admin/ghosting" class="gds-display-0 gds-link gds-link--bold">Search Accounts</a>
            </div>
            <div v-if="ghostAccounts && ghostAccounts.length > 0" class="global-panel__account-link">
              <button @click="ClearRecent()" type="button" class="gds-button gds-text-button">
                <span class="gds-button__text">Clear Recent Searches</span>
              </button>
            </div>
          </div>
          <div v-if="!isAdmin && !isAdminLite" class="gds-space-stack-m">
            <div
              v-for="account of accounts"
              :key="account.accountNumber"
              @click="SelectAccount(account)"
              @keyup.enter="SelectAccount(account)"
              class="global-panel__account-row"
              tabindex="0"
            >
              <div v-if="account.photoUrl" :style="{backgroundImage: 'url(' + GetResizedAccountPhoto(account.photoUrl) + ')'}" class="small-round-img"></div>
              <div v-if="!account.photoUrl" class="small-round-img"></div>
              <div>
                <p class="gds-display-0 gds-space-stack-s">{{account | accountName}}</p>
                <div class="gds-linebreaks">{{account.address | addressFormat({ separator: "\n", skipFirst: true })}}</div>
                <span v-if="account.isPrimary" class="global-panel__primary-badge">Primary</span>
              </div>
            </div>
            <div class="global-panel__account-link">
              <a href="/user-profile/accounts" class="gds-display-0 gds-link gds-link--bold">Add / Manage Accounts</a>
            </div>
          </div>
        </div>
      </FocusLock>
    </div>
  </transition>
</template>

<script>
import { GetResizedAccountPhoto } from "../utilities";

export default {
  name: "GlobalAccountPanel",
  data() {
    return {
      GetResizedAccountPhoto,
    };
  },
  computed: {
    isExpanded() {
      return this.$store.state.layout.accountswitchervisible;
    },
    accounts() {
      return this.$store.state.user.accounts;
    },
    ghostAccounts() {
      return this.$store.state.user.ghostAccounts;
    },
    isAdmin() {
      return !!this.$store.state.user.userinfo.isAdmin;
    },
    isAdminLite() {
      return !!this.$store.state.user.userinfo.isAdminLite;
    }
  },
  methods: {
    Close() {
      this.$store.commit("setAccountSwitcherVisible", false);
    },
    SelectAccount(account) {
      this.$store.commit("setCurrentAccount", account);
      this.Close();
    },
    ClearRecent() {
      this.$store.commit("clearGhostAccounts");
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>